import { Population } from '../enum/population.enum';
import { PopulationProps } from '../model/population-props.model';

export const PopulationPropsMap: { [key in Population]: PopulationProps } = {
    [Population.User]: { icon: 'account', label: 'User' },
    [Population.Team]: { icon: 'account-multiple', label: 'Team' },
    [Population.Lob]: { icon: 'briefcase', label: 'LOB' },
    [Population.Region]: { icon: 'earth', label: 'Region' },
    [Population.Area]: { icon: 'map-marker', label: 'Area' },
    [Population.Site]: { icon: 'domain', label: 'Site' },
    [Population.SuperGroup]: { icon: 'file-tree', label: 'SuperGroup' },
    [Population.PeerGroup]: { icon: 'account-group', label: 'PeerGroup' },
    [Population.Role]: { icon: 'shield-account', label: 'Role' },
    [Population.Queue]: { icon: 'tray-full', label: 'Queue' },
    [Population.PopulationGroup]: {
        icon: 'set-center',
        label: 'Population Group',
    },
};
